import { createSlice } from "@reduxjs/toolkit";
import { fetchBranchBalance } from "./branchBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    branchId: null,
  },
};

const branchBalanceSlice = createSlice({
  name: "branchBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.accounts || [];
      })
      .addCase(fetchBranchBalance.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = branchBalanceSlice.actions;
export default branchBalanceSlice.reducer;
